'use strict';

function controller(svc, pageStateService, localStorageService, $window) {
    const ctrl = this;

    ctrl.$onInit = () => {
        svc.initializeListing(ctrl.forced)
            .then((listing) => {
                ctrl.listingId = listing.listingId;
                ctrl.sellerId = listing.sellerId;
            })
            .then(() => {
                try {
                    const listingIdToSave = localStorageService.getItem('listingToSaveAfterLoginOrSignup');

                    if (listingIdToSave === null) {
                        return;
                    }

                    if (Number.parseInt(listingIdToSave) === ctrl.listingId && !svc.isVehicleSaved() && $window.document.cookie.indexOf('rememberMe') > -1) {
                        ctrl.saveToggle();
                    }

                    localStorageService.removeItem('listingToSaveAfterLoginOrSignup');
                } catch (err) {
                    // ignore error
                }
            });

    };

    ctrl.getVehicleText = function () {
        return svc.isVehicleSaved() ? 'SAVED' : 'SAVE';
    };

    ctrl.saveToggle = function () {
        if (svc.isVehicleSaved()) {
            svc.deleteVehicle();
        } else {
            if (svc.okToSave()) {
                svc.saveVehicle()
                    .then(() => {
                        pageStateService.push('event', {eventName: "lead", eventDetail: "save"}, true);
                    });
            } else {
                svc.forceSignup();
            }
        }
    };

    ctrl.isSaved = svc.isVehicleSaved;
}

controller.$inject = [
    'saveVehicleService',
    'pageStateService',
    'localStorageService',
    '$window'
];

export default controller;
